import {createFileRoute, redirect} from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_agency/agency/$agencyId/")({
  params: {
    parse: raw => ({agencyId: +raw.agencyId}),
    stringify: params => ({agencyId: params.agencyId?.toString()}),
  },
  loader: ({params}) => {
    throw redirect({
      to: "/agency/$agencyId/customers",
      params: {agencyId: +params.agencyId},
      replace: true,
    });
  },
});
